// Import
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import ButtonCst from "@components/ButtonCst";
import { Download } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import useSWRMutation from "swr/mutation";
import { downloadFile, ServicesURL } from "@utils/utilsApi";
import { fetcher } from "src/services/config";
import { MethodType } from "src/services/type";
import { useParams } from "react-router-dom";
import { useErrorContext } from "@context/ErrorContext";

interface SessionQRModalCstInterface {
  data?: any;
  title?: string;
  onCancelAction: () => void;
}

const SessionQRModalCst: React.FC<SessionQRModalCstInterface> = ({
  data,
  title,
  onCancelAction,
}) => {
  const { setErrorContext, setOpenErrorContext } = useErrorContext();

  const { t } = useTranslation(["upload-component"]);
  const { t: tTeacher } = useTranslation(["teachers-area-detail-page"]);
  const { id = "1", idLO, idEdition } = useParams();
  const [qrCode, setQrCode] = useState<{
    private_url: string;
    public_url: string;
  }>();

  const { trigger } = useSWRMutation(
    `${ServicesURL.getSessionQRCode}?activityId=${idLO}&corporateId=${id}&editionId=${idEdition}&sessionId=${data.id}&type=${
      data.qr_type === "start" ? "ENTRY" : "EXIT"
    }`,
    (url: string) => fetcher(url, MethodType.POST),
    {
      onError: (error) => {
        if (
          error?.response?.status !== 401 &&
          error?.response?.status !== 406
        ) {
          const detailMessage = error.response.data.errorMessage;
          setErrorContext({
            title: `Error ${error?.response?.status}`,
            content: tTeacher(`qr-modal-error.${detailMessage}`),
          });
          setOpenErrorContext(true);
          // throw error;
        }
      },
    },
  );

  let getQrCode = async () => {
    try {
      let result = await trigger();
      setQrCode(result);
    } catch (error) {
      console.error(error);
      onCancelAction();
    }
  };

  useEffect(() => {
    getQrCode();
  }, []);

  const onDownload = () => {
    downloadFile(`${qrCode?.public_url}`);
  };

  return (
    <Box
      sx={{
        minHeight: "200px",
        alignItems: "stretch",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h2 style={{ margin: "0" }} id="parent-modal-title">
          {title}
        </h2>
        <Button
          onClick={() => onCancelAction()}
          sx={{
            borderRadius: "50%",
            minWidth: "0",
            padding: "0 3px",
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
            span: {
              width: "0",
            },
          }}
        >
          <CloseIcon fontSize="large" />
        </Button>
      </Box>
      <Box
        sx={{
          display: "grid",
          justifyContent: "center",
          gap: "2rem",
          mt: "2rem",
        }}
      >
        <Box
          sx={{
            display: "grid",
            justifyContent: "center",
            alignContent: "center",
            gap: "2rem",
            height: "200px",
            width: "200px",
          }}
        >
          {qrCode && qrCode?.public_url && (
            <img src={`${qrCode?.public_url}`} alt="" />
          )}
          {!qrCode && <CircularProgress size={40} />}
        </Box>
        <ButtonCst
          id="add-file"
          variant="contained"
          onClick={() => onDownload()}
          disabled={!qrCode}
        >
          <Download /> {t("download")}
        </ButtonCst>
      </Box>
    </Box>
  );
};

export default SessionQRModalCst;
